/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-lonely-if */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { HiDownload } from 'react-icons/hi';
import { MdRemoveShoppingCart } from 'react-icons/md';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import TicketService from '../../services/ticket';
import DownLoadFile from '../../utils/DownLoadFile';
import { ArrayFilters } from '../../interfaces/ticket';
import { formatPrice } from '../../utils/currencyFormater';
import NoOrdersTable from './components/NoOrdersTable';
import { useToast } from '../../hooks/toast';
import Modal from '../../components/Modal';
import getValidationErrors from '../../utils/getValidationErrors';
import Input from '../../components/Input';
import AuthService from '../../services/auth';
import {
  Container,
  Title,
  ButtonsContainer,
  FormWrapper,
  ModalContent,
  LinkModal,
} from './styles';
import {
  Row,
  Column,
  IconContainer,
  InfoItem,
  InfoContainer,
} from '../../styles/components';
import { ButtonReCaptcha } from '../../components/ButtonReCaptcha';

const CardTicketReplaced: React.FC = () => {
  const services = { TicketService: new TicketService() };
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [titular, setTitular] = useState<any>();
  const { push } = useHistory();
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const formRefRelatorio = useRef<FormHandles>(null);
  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });
  const authService = { AuthService: new AuthService() };

  const [noRechargedTickets, setNoRechargedTickets] = useState<any>({});

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }, { 'number-days': 90 }],
  });

  const getTitular = useCallback(async () => {
    try {
      /* setLoading(true); */
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      /* setLoading(false); */
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  const getNoRecharged = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.TicketService.getNoRechargedTickets(
        filters,
      );
      setNoRechargedTickets(response.data);
      setPerPage(response.data.ListaDeCartoesQuantidade);
      setTotalRows(response.data.ListaDeCartoesTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleReport = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [
        { 'file-type': type === 'csv' ? 'C' : 'P' },
        { 'order-gte-days': 'S' },
      ],
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getNoOrdersReport(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `sempedidosderecarga.${type}`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possível executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);

  const RelatorioAgendados = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [
        { 'file-type': type === 'csv' ? 'C' : 'P' },
        { 'order-gte-days': 'S' },
      ],
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getNoOrdersReport(
        reportFilters,
        type,
      );
      console.log(response);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      } else {
        addToast({
          type: 'error',
          title: 'Não foi possível executar o serviço',
          description: 'Não existem dados para serem impressos.',
        });
      }
    }
  }, []);
  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendados('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendados('pdf');
  }, []);

  function relatorio() {
    push('/agendado');
  }

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
            { 'order-gte-days': 'S' },
          ],
        };

        await services.TicketService.getNoOrdersReport(reportFilters, type);

        addToast({
          type: 'success',
          title: 'Relatório exportado com sucesso, por favor, aguarde.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);

        addToast({
          type: 'error',
          title: `${err.response.data.message} ${err.response.data.sub_message}`,
        });
        const { ...error } = err;
        console.error(error);
      }
    },
    [titular],
  );

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
      }
    },
    [tipoRelatorio, titular],
  );

  const convertStringToDate = (dateString: any) => {
    const [day, month, year] = dateString.split('/').map(Number);
    // Mês no JavaScript começa do zero, então subtraia 1 do mês
    return new Date(year, month - 1, day);
  };

  const customSort = (dateA: any, dateB: any) => {
    if (dateA < dateB) {
      return -1;
    }
    if (dateA > dateB) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    getNoRecharged();
    getTitular();
  }, [filters]);

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <MdRemoveShoppingCart />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <div>
            <Title>Cartões sem pedido a mais de 90 dias</Title>
            {/* <p>
              Donec bibendum metus ac felis tristique mollis. Ut quis orci
              condimentum, faucibus purus in, posuere nunc. Donec bibendum, est
              sit amet auctor tincidunt, nisl purus sodales ligula, ut vehicula
              quam arcu vitae nunc.
            </p> */}
          </div>
        </Column>
      </Row>

      <ButtonsContainer>
        <div className="buttonsInitial">
          <ButtonReCaptcha
            disabled={titular?.BalanceView}
            modalTitle="GERAR CSV"
            onClick={async (data: any, cb: any) => {
              console.log({ data });
              if (titular.BalanceView === true) {
                if (titular.AsyncReport === true) {
                  openModalCSV();
                } else {
                  await handleReport('csv');
                }
              } else {
                if (titular.AsyncReport === true) {
                  openModalCSV();
                } else {
                  await handleReport('csv');
                }
              }
              cb();
            }}
            component={({ handle }) => (
              <Button
                color="purple"
                padding="1"
                type="button"
                className="csv"
                onClick={() => handle()}
              >
                <HiDownload />
                GERAR CSV
              </Button>
            )}
          />
          <ButtonReCaptcha
            disabled={titular?.BalanceView}
            modalTitle="GERAR PDF"
            onClick={async (data: any, cb: any) => {
              console.log({ data });
              if (titular.BalanceView === true) {
                if (titular.AsyncReport === true) {
                  openModalPDF();
                } else {
                  await handleReport('pdf');
                }
              } else {
                if (titular.AsyncReport === true) {
                  openModalPDF();
                } else {
                  await handleReport('pdf');
                }
              }
              cb();
            }}
            component={({ handle }) => (
              <Button
                color="purple"
                padding="1"
                type="button"
                className="pdf"
                onClick={() => handle()}
              >
                <HiDownload />
                GERAR PDF
              </Button>
            )}
          />
        </div>
      </ButtonsContainer>
      <Row>
        <Column small="2" medium="2" large="2">
          <InfoContainer>
            <InfoItem className="infoitem">
              <span className="info">&#9432;</span>
              <span className="ajuda">
                <p className="text">
                  Evite deixar os cartões a mais de 90 dias sem crédito. Após a
                  recarga eles estão ativos para utilização.
                </p>
                <p className="text">
                  Em caso de desligamento de colaborador, solicite a devolução
                  do cartão.
                </p>
              </span>
            </InfoItem>
          </InfoContainer>
        </Column>
        <Column small="10" medium="10" large="10">
          <NoOrdersTable
            data={noRechargedTickets.ListaDeCartoes}
            columns={[
              {
                name: 'Cartão VT',
                selector: 'DadosDeCartao',
                cell: ({ CrtCodIdentifExt }: any) => (
                  <div>{CrtCodIdentifExt}</div>
                ),
              },
              {
                name: 'Funcionário',
                selector: 'DadosDeFuncionario',
                cell: ({ Nome }: any) => <div>{Nome || '--'}</div>,
              },
              {
                name: 'Saldo',
                selector: 'IdentificadorCartaoVTNovo',
                cell: ({ Saldo }: any) => <div>{formatPrice(Saldo)}</div>,
              },
              {
                name: 'Validade do Cartão',
                selector: 'Fim da Validade',
              },
              {
                name: 'Ùltimo Pedido',
                sortable: true,
                selector: 'CodigoPedidoDeSegundaVia',
                sortFunction: (a: any, b: any) =>
                  customSort(
                    convertStringToDate(a.DataUltimoPedido),
                    convertStringToDate(b.DataUltimoPedido),
                  ),
                cell: ({ DataUltimoPedido }: any) => (
                  <div>{DataUltimoPedido}</div>
                ),
              },
            ].filter((column: any) => {
              console.log({ column });
              if (column?.name === 'Saldo') {
                if (titular?.BalanceView) {
                  return true;
                }
                return false;
              }
              return true;
            })}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Não há cartões sem pedido há mais de 90 dias"
          />
        </Column>
      </Row>
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}

      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}
    </Container>
  );
};

export default CardTicketReplaced;
